/** Предопределённые коды операций/прав пользователя на БО. */
export enum API_USER_OPERATION_LIST {
    "Просмотр объекта" = -3,
    "Редактирование объекта" = -2,
}

/** Элемент ответа `bo.rights.check`. */
export interface ApiBoCheckRightRes {
    BOCode: number;
    RightCode: number;
    /** `true` — право есть */
    HasRight: boolean;
    ErrorCode: number;
    ErrorText: string;
}
